import {Component, Input, OnInit} from '@angular/core';
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {StudyHistory} from "../../../types/interfaces";
import {Router} from "@angular/router";
import {APP_HOST} from "../../../../providers/config";

@Component({
    selector: 'app-certificate',
    templateUrl: './certificate.component.html',
    styleUrls: ['./certificate.component.scss'],
})
export class CertificateComponent implements OnInit {

    @Input() group: StudyHistory|undefined = undefined;


    constructor(public myGcService: MyGreenCountry,   public router: Router,) {
    }

    ngOnInit() {
    }

    async openCertificate(url: string) {
       let  route = url.replace(APP_HOST, "");

       this.router.navigate([ route]);

        // this.myGcService.openUrl(url)
    }

}
